module.exports = __webpack_public_path__ + "static/media/Marcel Dewit Notice of Proposal to Revoke a Licence_1.308d57f9.pdf";